import { fmt } from "@/lib/format";
import { useTab } from "@/hooks/useTab";
import { useFilters } from "@/hooks/useFilters";
import { RankingRow } from "@/components/cards/RankingRow";
import { KpiCard } from "@/components/cards/KpiCard";
import { EmptyState, ErrorState, SectionTitle, TabSkeleton } from "./shared";

/** Tab 2 — Teams ranking. Only meaningful when scope=all, so the
 * TabsNav disables it otherwise and we still render a friendly empty. */
export function TeamsTab() {
  const { filters } = useFilters();
  const { data, isPending, error } = useTab("teams", filters);

  if (filters.scope !== "all") {
    return (
      <EmptyState
        title="Equipos solo se muestra con alcance 'Todos'."
        description="Cambia el filtro de alcance para ver el ranking de equipos."
      />
    );
  }

  if (isPending) return <TabSkeleton />;
  if (error) return <ErrorState error={error} />;
  if (!data || data.ranking.length === 0) {
    return <EmptyState title="Sin datos de equipos en este periodo." />;
  }

  const { metrics } = data;

  return (
    <div className="flex flex-col gap-8">
      <section className="grid grid-cols-3 gap-3">
        <KpiCard label="Equipos" value={fmt(metrics.total_teams)} />
        <KpiCard label="Miembros totales" value={fmt(metrics.total_members)} />
        <KpiCard
          label="Adopción global"
          value={`${metrics.global_adoption_pct.toFixed(1)}%`}
        />
      </section>

      <section>
        <SectionTitle>Ranking por equipo</SectionTitle>
        <div className="flex flex-col gap-2">
          {data.ranking.map((row) => (
            <RankingRow
              key={row.team}
              rank={row.rank}
              username={row.team}
              team={`${row.active} / ${row.members} activos · ${row.adoption_pct.toFixed(0)}% adopción`}
              score={fmt(row.per_capita)}
              metricLabel="per cápita"
              secondary={{
                value: fmt(row.total),
                label: "total",
              }}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
